import { Navigate, Route, Routes } from "react-router-dom";
import { AdminGate } from "./app/AdminGate.js";
import { Layout } from "./app/Layout.js";
import { UsersPage } from "./features/users/UsersPage.js";
import { NodesPage } from "./features/nodes/NodesPage.js";
import { StreamsPage } from "./features/streams/StreamsPage.js";
import { SettingsPage } from "./features/settings/SettingsPage.js";
import { SetupWizard } from "./features/setup/SetupWizard.js";

export function App() {
  return (
    <AdminGate>
      <Routes>
        {/* Setup view is reachable directly; AdminGate forces it when uninitialized. */}
        <Route path="/setup" element={<SetupWizard />} />

        <Route element={<Layout />}>
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:id" element={<UsersPage />} />
          <Route path="/nodes" element={<NodesPage />} />
          <Route path="/nodes/:id" element={<NodesPage />} />
          <Route path="/streams" element={<StreamsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/" element={<Navigate to="/users" replace />} />
          <Route path="*" element={<Navigate to="/users" replace />} />
        </Route>
      </Routes>
    </AdminGate>
  );
}
